import React from 'react';
import PropTypes from 'prop-types';
import Calendar from '../../common/Calendar/Calendar';

const DailySidePanel = props => (
  <div>
    <Calendar {...props} />
  </div>
);

DailySidePanel.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
};

export default DailySidePanel;
